module.exports = __webpack_public_path__ + "images/cd5a9d117e69c5d3e38b8c0d0b86da49.png";